export default "__VITE_ASSET__DVUmkrPC__"